import {useContext, useEffect} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {useAuthToken} from 'src/hooks/AuthHooks';
import {PortalContext} from 'src/hooks/PortalContext';
import {getAllSaas} from 'src/services/SaasService/Saases';
import {
  cacheKeyForAllSaas,
} from 'src/services/shared/serviceConstants';

// Prefetch as much as feasible

// Rendered inside the PortalContext provider: the SaaS catalogue
// depends on the selected client.
export const BaseDataLoader = () => {
  // console.log('BaseDataLoader running');
  const queryClient = useQueryClient();

  const {token} = useAuthToken();
  const clientInfo = useContext(PortalContext)?.clientInfo;

  useEffect(()=> {
    const readyToPrefetch = !!token && !!queryClient && !!clientInfo;
    // console.log('useEffect', {token}, {queryClient}, {readyToPrefetch});
    if (readyToPrefetch) {
      // prefetch the SaaSes the selected client may add
      queryClient.prefetchQuery({
        queryKey: cacheKeyForAllSaas(clientInfo.id),
        queryFn: () => getAllSaas({
          accessToken: token,
          queryContext: {client: clientInfo},
        })
    });
    }
   }, [token, queryClient, clientInfo]
  );

  return null;
};
